import { render, staticRenderFns } from "./PlaceImageCard.vue?vue&type=template&id=869e8654&scoped=true"
import script from "./PlaceImageCard.vue?vue&type=script&lang=js"
export * from "./PlaceImageCard.vue?vue&type=script&lang=js"
import style0 from "./PlaceImageCard.vue?vue&type=style&index=0&id=869e8654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869e8654",
  null
  
)

export default component.exports